module.exports = __webpack_public_path__ + "static/media/diy.26234a52.JPG";